import React from 'react';
import { PageTitleZoneNext } from '../../../../components/page-title-zone';
import { formatDate } from '../../../../utilities';

export interface ICitizenLessonDeviationTitlezoneProps {
  isEditMode: boolean;
  isReadOnly: boolean;
  citizenName?: string;
  lessonDate?: string | Date;
}

export function CitizenLessonDeviationTitlezone(props: ICitizenLessonDeviationTitlezoneProps) {
  const { isEditMode, isReadOnly, citizenName, lessonDate } = props;
  const title = getTitle(isEditMode, isReadOnly);
  const formattedDate = formatDate(lessonDate);
  const subtitle = [citizenName, formattedDate && `(${formattedDate})`].filter(Boolean).join(' ');
  return <PageTitleZoneNext isLoading={false} entityName="Særplan" title={title} subtitle={subtitle} />;
}

function getTitle(isEditMode: boolean, isReadOnly: boolean) {
  if (isReadOnly) {
    return 'Vis særplan';
  }

  return isEditMode ? 'Redigér særplan' : 'Opret særplan';
}
